import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import type { CopilotAccountOption } from '../store/schema/CopilotAccountPickerStoreSchema';
import type { MailboxInfo } from 'owa-client-types';

export const setAccountOptionsMutator: (options: CopilotAccountOption[]) => void = mutatorAction(
    'setAccountOptionsMutator',
    (options: CopilotAccountOption[]): void => {
        const store = getStore();
        store.accountOptions = options;
    }
);

export const setCurrentAccountMutator: (account: MailboxInfo) => void = mutatorAction(
    'setCurrentAccountMutator',
    (account: MailboxInfo): void => {
        getStore().currentAccount = account;
    }
);

export const resetCopilotAccountPickerDialogStoreMutator: () => void = mutatorAction(
    'resetCopilotAccountPickerDialogStoreMutator',
    (): void => {
        const store = getStore();
        store.currentAccount = null;
        store.accountOptions = [];
    }
);
